import $ from 'jquery';

$(document).ready(() => {
    function my_video() {
        var $videoSrc;
        $('.content-img-vid .video-btn').click(function() {
            $videoSrc = $(this).data( "src" );
            console.log($videoSrc + '1')
        });
        // when the modal is opened autoplay it
        $('#myModal').on('shown.bs.modal', function (e) {

            // set the video src to autoplay and not to show related video.lates...
            $("#video").attr('src',$videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0" );
        })
        // stop playing the youtube video when I close the modal
        $('#myModal').on('hide.bs.modal', function (e) {
            $("#video").attr('src',$videoSrc);
        })
    }
    my_video()
})

